/** Angular `/reports/...` → React child under `/reports`; `/imap-logs` stays top-level. */
export function angularPathToReactSegment(angularPath: string): string {
  if (angularPath === '/imap-logs') return 'imap-logs'
  return angularPath.replace(/^\/reports\//, '')
}

/** Full browser path for a report (Angular URL shape). */
export function buildDashboardReportPath(angularPath: string): string {
  if (angularPath === '/imap-logs') return '/imap-logs'
  return `/reports/${angularPathToReactSegment(angularPath)}`
}
